// src/hooks/useQuoteSnooze.js
// s5portal-8a3d6f21 — S5, security audit 2026-10-02 #7.
//
// The CURRENT snooze record for ONE estimate:
//   organizations/{orgId}/quoteSnoozes/{quoteId}  →  { reason, until, untilHasTime, setAt, setBy }
// Written only by Cloud Functions (functions/utils/quoteFollowUp.js runSetQuoteSnooze; deleted by
// Wake now and the elapsed sweep). The reason used to sit on the quote as `snoozeReason`, where
// the customer portal could read it — portal customers download whole quote documents. This
// collection is staff-read with NO portal clause in firestore.rules, so this hook must never be
// used in a portal view.
//
// Callers still decide "is it snoozed?" from quote.snoozedUntil (isSnoozed); this record only
// supplies the wording. Returns { reason, loaded }.
import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

export default function useQuoteSnooze(orgId, quoteId, enabled = true) {
    const [state, setState] = useState({ reason: null, loaded: false });

    useEffect(() => {
        if (!enabled || !orgId || !quoteId) { setState({ reason: null, loaded: false }); return undefined; }
        setState({ reason: null, loaded: false });
        return onSnapshot(
            doc(db, `organizations/${orgId}/quoteSnoozes`, quoteId),
            (snap) => setState({ reason: snap.exists() ? (snap.data().reason || null) : null, loaded: true }),
            (err) => {
                console.warn('useQuoteSnooze: subscription failed', err);
                setState({ reason: null, loaded: true });
            }
        );
    }, [orgId, quoteId, enabled]);

    return state;
}
